import React from "react";
import './Footer.css';

const Cblock = () => {
    return ( 
        <div className="Cblock">
            <h2>CONTACT</h2>
        </div>
    );
}
 
export default Cblock;